import React, { useState } from 'react';
import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { HouseSimple } from '@phosphor-icons/react';
import { DistanceViewIcon } from '../../../../assets/Icons/DistanceView.component';
import { WareHouseDraw } from '../../../../assets/Icons/WareHouseDraw.component';
import { useQuantitatives } from '../../../../contexts/QuantitativesContext';
import { Elevation } from '../../../../assets/Icons/Elevation.component';
import { formatValue } from '../../../../utils/formatValue';
import { IndicatorElement } from '../../../IndicatorElement/IndicatorElement.component';
import { ArrowWaterDown } from '../../../../assets/Icons/ArrowWaterDown.component';
import { ArrowWaterUp } from '../../../../assets/Icons/ArrowWaterUp.component';
import * as S from './WarehouseView.styles';

export function WarehouseView() {
  const { measures } = useQuantitatives();
  const [viewImage, setViewImage] = useState<'DistanceView' | 'HouseSimple'>('DistanceView');

  const iconColors: Record<string, string> = {
    HouseSimple: viewImage === 'HouseSimple' ? '#022D58' : '#B3B3B3',
    DistanceView: viewImage === 'DistanceView' ? '#022D58' : '#B3B3B3',
  };

  const numEspacos = Math.ceil(measures.comprimento / measures.distanciaPort);

  return (
    <Flex>
      <Flex
        flexDir="column"
        p="1rem"
        gap="3.5rem"
        borderTopLeftRadius="0.75rem"
        borderBottomLeftRadius="0.75rem"
        bgColor="#EDEDED"
        borderRight="1px solid #B3B3B3"
        justifyContent="center"
      >
        <DistanceViewIcon
          color={iconColors.DistanceView}
          onClick={() => {
            setViewImage('DistanceView');
          }}
        />
        <Icon
          as={HouseSimple}
          color={iconColors.HouseSimple}
          w="26px"
          h="26px"
          cursor="pointer"
          onClick={() => {
            setViewImage('HouseSimple');
          }}
        />
      </Flex>
      <Flex
        borderTopRightRadius="0.75rem"
        borderBottomRightRadius="0.75rem"
        flex="1"
        bgColor="#F4F4F4"
        p="5rem 3rem"
        w="100%"
      >
        <Box margin="auto">
          {viewImage === 'DistanceView' && (
            <Box p="0.6rem" bgColor="#EDEDED" w="max-content" border="1px dashed #979797">
              <S.RetanguloStyled
                $largura={measures.largura}
                $comprimento={measures.comprimento}
                $distanciaportico={measures.distanciaPort}
              >
                <S.TrianguloIconContainer>
                  <Elevation />
                </S.TrianguloIconContainer>
                <S.IndicadorAguaCima>
                  <Icon as={ArrowWaterUp} boxSize={5} />
                </S.IndicadorAguaCima>
                <S.IndicadorAguaBaixo>
                  <Icon as={ArrowWaterDown} boxSize={5} />
                </S.IndicadorAguaBaixo>

                <S.CotaLargura>{formatValue(measures.largura)}m</S.CotaLargura>
                <S.CotaComprimento $espacamentos={numEspacos}>
                  {formatValue(measures.comprimento)}m
                </S.CotaComprimento>
                {Array.from({ length: Math.min(numEspacos, 21) }).map((_, index) => (
                  <S.RetanguloPortico
                    key={window.crypto.randomUUID()}
                    $largura={measures.largura}
                    $comprimento={measures.comprimento}
                    $distanciaportico={measures.distanciaPort}
                    $espacamentos={numEspacos}
                  >
                    <Text as="span">{formatValue(measures.distanciaPort, 1)}m</Text>
                    {index === 0 && (
                      <>
                        <S.DotTopFirst />
                        <S.DotBottomFirst />
                      </>
                    )}
                    <S.DotTop />
                    <S.DotBottom />
                    <S.TopLine />
                    <S.CenterLine />
                    <S.BottomLine />
                  </S.RetanguloPortico>
                ))}
              </S.RetanguloStyled>
            </Box>
          )}
          {viewImage === 'HouseSimple' && (
            <Flex flexDir="column" w="38rem">
              <Flex justifyContent="center" position="relative">
                <WareHouseDraw />
                <S.CotaAlturaElevacao $altura={measures.altura} />
                <Box position="absolute" top="-20px" left="200px">
                  <IndicatorElement value="1" />
                </Box>
                <Box position="absolute" top="-10px" left="100px">
                  <IndicatorElement value="2" />
                </Box>
                <Box position="absolute" top="45px" left="80px">
                  <IndicatorElement value="3" />
                </Box>
                <Box position="absolute" top="50%" left="20px">
                  <IndicatorElement value="4" />
                </Box>
              </Flex>
              <Box bgColor="#B3B3B3" height="50px" w="100%" position="relative">
                <S.CotaLarguraElevavacao>{measures.largura}m</S.CotaLarguraElevavacao>
              </Box>
            </Flex>
          )}
        </Box>
      </Flex>
    </Flex>
  );
}
